import {IHttpService} from "angular";
import {RiskLimits, RiskSummaryRecord} from "../models/RiskSummaryRecord";

export class RiskService {

    public static id = "riskService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {

    }

    public async summary() {
        const response = await this.$http.get<RiskSummaryRecord>("/tradefloor/api/risk_dashboard");
        return response.data!;
    }

    public async updatePortfolioRiskLimits(portfolioId: number, riskLimits: RiskLimits): Promise<void> {
        const riskLimitsCopy = {
            stelLimit : riskLimits.stelLimit,
            marginLimit : riskLimits.marginLimit,
            cbplLimit: riskLimits.cbplLimit,
            marginLevel: riskLimits.marginLevel
        };

        await this.$http.post<void>(`/tradefloor/api/risk_dashboard/portfolio/${portfolioId}/limits`, riskLimitsCopy);
    }

    public async updateOrgGroupRiskLimits(orgGroupId: number, riskLimits: RiskLimits): Promise<void> {
        const riskLimitsCopy = {
            stelLimit : riskLimits.stelLimit,
            marginLimit : riskLimits.marginLimit,
            cbplLimit: riskLimits.cbplLimit,
            marginLevel: riskLimits.marginLevel
        };
        await this.$http.post<void>(`/tradefloor/api/risk_dashboard/org/${orgGroupId}/limits`, riskLimitsCopy);
    }
}
